export default "__VITE_ASSET__BR9xIr5J__"